module.exports = __webpack_public_path__ + "static/media/Logo-RL_white.6e7f774f.png";